export default "__VITE_ASSET__Cn3p13uf__"